var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-chip"},[_c('v-chip',_vm._g(_vm._b({attrs:{"label":"","small":"","text-color":_vm.textColor}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.texto)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }